import Vue from 'vue';
import initialState from './state';

export default {
  setManifests(state, manifests) {
    state.manifests = manifests;
  },
  addManifest(state, manifest) {
    state.manifests.push(manifest);
  },
  updateManifest(state, update) {
    const index = state.manifests.findIndex(manifest => manifest.id === update.id);
    if (index !== -1) {
      Vue.set(state.manifests, index, { ...state.manifests[index], ...update });
    }
  },
  reset(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, initialState());
  },
};
